<template>
  <div v-if="hasPermission(permissions.leadSourcesCreate)">
    <content-header>{{ $t('createLeadSource') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :is-loading="isLoading" />
            <submit-input :name="$t('create')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import {LeadSource} from "@/models/LeadSource";
import SubmitInput from "@/components/Inputs/SubmitInput";
import TextInput from "@/components/Inputs/TextInput";
import {permissions} from "@/plugins/constants";

export default {
  name: "LeadSourceCreate",
  components: {TextInput, ContentHeader, 'v-content': Content, IsLoading, SubmitInput},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new LeadSource().fillAbles),
      isLoading: false,
      permissions: permissions
    }
  },
  validations: {
    form: {
      name: {required},
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('leadSources/CREATE', this.form).then(() => {
        this.$v.$reset();
        this.$router.push({name: "leadSources"})
      }).catch(() => this.isLoading = false);
    },
  }
}
</script>
